import type { Messages } from '../i18n/messages';

export const sentryMessages: Messages = {
  // "Sentry" is a brand/product name — identical en/fun.
  'sentry.entityContent.title': { en: 'Sentry', fun: 'Sentry' },
  'sentry.issuesView.cardTitle': {
    en: 'Sentry issues',
    fun: 'Sentry drama',
  },
  'sentry.issuesView.timeRangeLabel': {
    en: 'Time range',
    fun: 'How far back?',
  },
  'sentry.issuesView.columnError': { en: 'Error', fun: 'Uh-oh' },
  'sentry.issuesView.columnLevel': { en: 'Level', fun: 'Drama level' },
  'sentry.issuesView.columnEvents': { en: 'Events', fun: 'How many times' },
  'sentry.issuesView.columnUsers': { en: 'Users', fun: 'Victims' },
  'sentry.issuesView.columnLastSeen': {
    en: 'Last seen',
    fun: 'Last spotted',
  },
  'sentry.issuesView.window24h': { en: '24H', fun: 'Past day' },
  'sentry.issuesView.window7d': { en: '7D', fun: 'Past week' },
  'sentry.issuesView.window14d': { en: '14D', fun: 'Past fortnight' },
  'sentry.issuesView.windowAll': { en: 'All', fun: 'Everything' },
  'sentry.issuesView.errorTitle': {
    en: 'Could not load Sentry issues',
    fun: 'Sentry ghosted us',
  },
  'sentry.issuesView.loadingLabel': {
    en: 'Loading Sentry issues…',
    fun: 'Rounding up Sentry issues…',
  },
  'sentry.issuesView.emptyTitle': {
    en: 'No unresolved issues',
    fun: 'Nothing on fire',
  },
  'sentry.issuesView.emptyDescription': {
    en: 'Nothing in the selected time window — try a wider range.',
    fun: 'Quiet in this window — try casting a wider net.',
  },
};
